import { Menu, Transition } from "@headlessui/react"
import * as React from "react"
import { FC, Fragment } from "react"
import { KSpan, KTooltip } from "kahuna-base-react-components"
//@ts-ignore
import { AdminUserMenuProps } from "../../../../../types"
import { RootState } from "../../../../../store"
import { fetchUserData } from "../../../../../actions"
import { connect } from "react-redux"
import { toast } from "react-toastify"
import {
  ADMIN_PERMISSIONS,
  AdminUserModalOptions,
  artistRoleList,
  errorFilledToastOptions,
  USER_ROLE
} from "../../../../../constants"
import { useNavigate } from "react-router-dom"
import { users } from "../../../../../apis"
import { checkAdminPermission } from "../../../../../utility"

const AdminUserMenu: FC<AdminUserMenuProps> = (props) => {
  const { setModal } = props
  const navigate = useNavigate()

  const onChangeUser = () => {
    users(`/change_user/?user_id=${props.user.id}`, "get")
      .then((resp) => {
        if (resp?.data?.token) {
          localStorage.setItem("token", resp.data.token)
          props.fetchUserData().then(() => {
            navigate("/")
          })
        } else {
          toast.error("Error changing account", errorFilledToastOptions)
        }
      })
      .catch((err) => toast.error("Error changing account", errorFilledToastOptions))
  }

  return (
    <Menu as="div" className="ml relative">
      <div>
        <Menu.Button data-TestId="admin-user-menu-button" className={"focus:outline-none"}>
          <div className="w-9 h-9 p-2 rounded-[10px] flex items-center justify-center bg-[#F7F7F7] hover:bg-[#F3F3F3]">
            <img
              className="min-w-5 min-h-5"
              src={"/admin_icons/horizontal-dots.svg"}
              width={20}
              height={20}
              alt="dots-icon"
            />
          </div>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={`z-20 origin-top-right absolute ${
            props.userDetailPage ? "left-[100%]" : "right-0"
          } mt-2 p-2 rounded-md shadow-lg py-1 bg-[#F7F7F7] ring-1
          ring-black ring-opacity-5 focus:outline-none flex flex-col divide-y divide-gray-200`}
        >
          <div className="flex flex-col px-1 py-1 gap-1 z-20 w-[220px]">
            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_RELOAD_REPORT, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-reload-report"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.RELOAD)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/loading.svg" width={20} height={20} />
                    <KSpan text="Reload" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}
            {checkAdminPermission(ADMIN_PERMISSIONS.USER_TAKEDOWN_WRITE, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-user-takedown"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.USER_TAKEDOWN)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/music-library.svg" width={20} height={20} />
                    <KSpan text="+ User Takedown" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}
            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_WRITE, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-user-takedown"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      if (!props.user.userTakedown) {
                        return
                      }
                      setModal(AdminUserModalOptions.AGREEMENTS_AND_PAYOUTS)
                    }}
                  >
                    <img
                      className="min-w-5 min-h-5"
                      src={
                        props.user.userTakedown
                          ? "/admin_icons/contract-icon.svg"
                          : "/admin_icons/contract-icon-disabled.svg"
                      }
                      width={20}
                      height={20}
                    />
                    {props.user.userTakedown ? (
                      <KSpan text="Agreements & Payouts" color={"#000"} />
                    ) : (
                      <KTooltip
                        width="120px"
                        position="left"
                        children={<KSpan text="Agreements & Payouts" color={"#66666644"} />}
                        content={<KSpan text="Initialize User Takedown first" />}
                      />
                    )}
                  </div>
                )}
              </Menu.Item>
            )}

            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_WRITE, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-payment-methods"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.PAYMENT_METHODS)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/wallet.svg" width={20} height={20} />
                    <KSpan text="Payment methods" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}
            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_WRITE, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-user-contract"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.USER_CONTRACT)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/file.svg" width={20} height={20} />
                    <KSpan text="User Contract" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}
            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_WRITE, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-user-credits"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.USER_CREDITS)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/user-gray.svg" width={20} height={20} />
                    <KSpan text="User credits" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}
            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_ADVANCE, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-user-advance"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.USER_ADVANCE)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/money-cash-grey.svg" width={20} height={20} />
                    <KSpan text="User advance" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}
            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_WRITE, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-affiliate-from-list"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.AFFILIATE_FROM_LIST)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/soundwave.svg" width={20} height={20} />
                    <KSpan text={`Affiliate from list (${props.affiliateFromList?.length})`} color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}
            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_WRITE, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-affiliate-to-list"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.AFFILIATE_TO_LIST)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/soundwave.svg" width={20} height={20} />
                    <KSpan text={`Affiliate to list (${props.affiliateToList?.length})`} color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}
            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_SEND_NOTIFICATION, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-send-notification"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.SEND_NOTIFICATION)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/notification.svg" width={20} height={20} />
                    <KSpan text="Send notification" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}

            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_WRITE, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-user-expense"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.USER_EXPENSE)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/user-gray.svg" width={20} height={20} />
                    <KSpan text="User expense" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}

            {checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_LOGS, props.authUser?.adminPermissions) && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-user-logs"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => window.open(`/admin/user-asset?log_user_id=${props.user.id}`, "_blank")}
                  >
                    <img className="min-w-5 min-h-5" src="/catalog_icons/history.svg" width={20} height={20} />
                    <KSpan text="User Logs" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}

            {!artistRoleList.includes(props.user.roleId) && props.authUser?.roleId === USER_ROLE.SuperAdmin && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    data-testid="admin-user-menu-permission"
                    className="flex flex-row gap-2 items-center w-full py-2.5 px-2 bg-[#F7F7F7] hover:bg-[#F3F3F3] rounded-[10px] cursor-pointer"
                    onClick={() => {
                      setModal(AdminUserModalOptions.ADMIN_PERMISSION)
                    }}
                  >
                    <img className="min-w-5 min-h-5" src="/admin_icons/shield-keyhole.svg" width={20} height={20} />
                    <KSpan text="Admin Permissions" color="#000" />
                  </div>
                )}
              </Menu.Item>
            )}

            {artistRoleList.includes(props.user.roleId) &&
              checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_GO_TO_PROFILE, props.authUser?.adminPermissions) && (
                <Menu.Item>
                  {({ active }) => (
                    <div
                      data-testid="admin-user-menu-go-to-profile"
                      className="mt-2 flex flex-row gap-2 items-center w-full py-3.5 px-2 bg-[#000] hover:bg-[#111] rounded-[10px] cursor-pointer"
                      onClick={() => {
                        onChangeUser()
                      }}
                    >
                      <img
                        className="min-w-5 min-h-5"
                        src="/admin_icons/user-circle-white.svg"
                        width={20}
                        height={20}
                      />
                      <KSpan text="Go to profile" color="#FFF" />
                    </div>
                  )}
                </Menu.Item>
              )}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    affiliateFromList: state.admin.affiliateFromList,
    affiliateToList: state.admin.affiliateToList,
    authUser: state.auth.user
  }
}

export default connect(mapStateToProps, {
  fetchUserData
})(AdminUserMenu)
